import debug from "src/modules/debug-logger";
import { Type } from "src/modules/media-upload-protobuf";

const MIN_BUFFER_TO_SEND_LENGTH = 500;

export default async function uploadData({ ws, media }) {
  let bufferToSend;
  let buffers = [];

  function prepareFinalBuffer(bufferLength) {
    if (!buffers || buffers.length === 0) return;
    let finalBuffer = new Uint8Array(bufferLength);

    let offset = 0;
    for (let buffer of buffers) {
      finalBuffer.set(buffer, offset);
      offset += buffer.byteLength;
    }
    bufferToSend = finalBuffer;
    sendDataMessage();
  }

  function sendDataMessage() {
    const message = Type.Message.create({
      dataMessage: Type.DataMessage.create({ data: bufferToSend })
    });
    ws.send(Type.Message.encode(message).finish());

    bufferToSend = null;
    buffers = [];
  }

  async function fillBuffer() {
    try {
      const bytes = media.audioData.shift();
      if (!bytes) {
        return new Promise((resolve) => {
          setTimeout(() => {
            if (media.finishUpload) {
              debug.activityLog(
                `finishing upload for file ${media.fileName}...`
              );
              let bufferLength = 0;
              for (let buffer of buffers) {
                bufferLength += buffer.byteLength;
              }
              prepareFinalBuffer(bufferLength);
            }
            resolve(media.finishUpload ? false : true);
          }, 200);
        });
      }

      buffers.push(bytes);
      return true;
    } catch (err) {
      debug.activityLog(`Error uploading media ${media.fileName}: ${err}`);
      return false;
    }
  }

  let keepReading = true;

  while (keepReading) {
    keepReading = await fillBuffer();
    let bufferLength = 0;
    for (let buffer of buffers) {
      bufferLength += buffer.byteLength;
    }

    if (bufferLength >= MIN_BUFFER_TO_SEND_LENGTH) {
      prepareFinalBuffer(bufferLength);
    }
  }
}
